import { useMutation } from '@tanstack/react-query';

import { generatePropertySummary } from '~/services/PropertySummaryService';

export function useGeneratePropertySummary() {
  return useMutation({
    mutationFn: generatePropertySummary,
  });
}
